module.exports = "/_next/static/media/4503e9164675ca489bb9ab3a31214c79.svg";